import React, { useCallback, useContext } from "react"
import { UpdateAvailableNotice } from "@stjeans/shared-frontend/layout"
import AppContext from "../../AppContext.jsx"
import skipWaiting from "../../serviceWorker/skipWaiting.js"

/**
 * @param {{ placement?: "sidebar" | "mobileTopBar" }} props
 */
export default function UpdateAvailable({ placement = "sidebar" }) {
  const { app, setApp: rawSetApp } = useContext(AppContext)
  const setApp = /** @type {any} */ (rawSetApp)

  const onUpdate = useCallback(() => {
    setApp((prev) => ({ ...prev, updateSelected: true }))
    skipWaiting()
  }, [setApp])

  return (
    <UpdateAvailableNotice
      updateAvailable={app.updateAvailable}
      onUpdate={onUpdate}
      placement={placement}
    />
  )
}

export function UpdateAvailableMobileAction() {
  return <UpdateAvailable placement="mobileTopBar" />
}
